import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_ConsentReceiveServices = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_ConsentReceiveServices' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Consent To Receive Services</h3></p>
                <p className='w-750'>
                    The information which I have provided as a condition of receiving services is
                    true and complete to the best of my knowledge. I consent to receive services as
                    may be recommended by the professional staff. I understand the professional staff may
                    discuss the services being provided to me, and that I may request the names of those involved.
                    I further understand that my failure to comply with therapeutic recommendations of the professional
                    staff may result in my being discharged.
                </p>
                <p className='w-750'>
                    I understand that I have the freedom of choice to receive services in a setting
                    that is integrated in and supports full access to the greater community; and is a
                    setting that facilitates individual choice regarding services and supports, and who provides them.
                </p>
                <p className='w-750'>
                    I understand that State and federal laws and regulations prohibit any entity
                    receiving confidential information from redistributing the information to any
                    other entity without the specific written consent of the person to whom it pertains or
                    as otherwise permitted by law and regulations.
                </p>
                <p className='w-750'>
                    I understand that confidential information may be released without my consent
                    when necessary for continued services; when release is necessary for the determination
                    of eligibility for benefits, compliance with statutory reporting requirements, or other
                    lawful purpose; if you communicate to the treating physician, psychologist, master social
                    worker or licensed professional counselor an actual threat of physical violence against a clearly
                    identified or reasonably identifiable potential victim or victims; in compliance with reporting requirements
                    under state law of incidents of suspected child abuse or neglect, or by court order.
                </p>


            </div>
        </form >

    )
}











